import { render } from "./KraReview.vue?vue&type=template&id=2b232386"
import script from "./KraReview.vue?vue&type=script&lang=js"
export * from "./KraReview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__